//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from 'vuex'
import { DEFAULT_REPORT_IMAGES_CATEGORIES_MAP } from './Report.js'
import ReportCityMessengerBotSection from './ReportCityMessengerBotSection.vue'
import ReportRemarks from './ReportRemarks.vue'
import ReportMaterials from './ReportMaterials/ReportMaterials.vue'
import ReportCheckList from './ReportCheckList/ReportCheckList.vue'
import ReportCheckListLegend from './ReportCheckList/ReportCheckListLegend.vue'
import ReportImages from './ReportImages.vue'
import ReportDocFiles from './ReportDocFiles.vue'
import ReportStateChanges from './ReportStateChanges.vue'
import ReportReworks from './ReportReworks.vue'
import ReportEditWorkTypes from './ReportEditWorkTypes.vue'
import RequestInitialization from '../Request/RequestInitialization.vue'
import ReportExecutor from './ReportExecutor.vue'
import ReportReinforcementExecutor from './ReportReinforcementExecutor.vue'
import DocumentAuditRemarks from '../Request/DocumentAuditRemarks.vue'
import ReportProjectSection from './ReportProjectSection.vue'
import ReportForkliftTruck from './ReportForkliftTruck/ReportForkliftTruck.vue'
import ReportObjectAvatar from './ReportObjectAvatar.vue'
import ReportYandexTasks from './ReportYandexTasks.vue'
import RequestRemontPositionField from '../Request/RequestRemontPositionField.vue'
import ServiceObjectMaintenanceNotesTable from '../../forms/ServiceObjectMaintenanceNote/ServiceObjectMaintenanceNotesTable.vue'
import ReportRemarkImportantCheckbox from './ReportRemarkImportantCheckbox.vue'
import ReportCheckListFilter from './ReportCheckListFilter.vue'
import ReportContentSection from './ReportContent/ReportContentSection.vue'
import { reportCheckListFilter } from './ReportCheckListFilter.js'
import { EventBus } from '../../EventBus/EventBus'
import { loadObjectActiveRequests } from '../Request/Request.js'
import { axiosGet } from '../../axios/axios'

export default {
  components: {
    ReportCityMessengerBotSection,
    ReportProjectSection,
    ReportForkliftTruck,
    ReportRemarks,
    ReportImages,
    ReportDocFiles,
    ReportStateChanges,
    ReportReworks,
    ReportCheckList,
    ReportMaterials,
    ReportEditWorkTypes,
    RequestInitialization,
    ReportExecutor,
    ReportReinforcementExecutor,
    DocumentAuditRemarks,
    ReportObjectAvatar,
    ServiceObjectMaintenanceNotesTable,
    ReportContentSection,
    ReportYandexTasks,
    RequestRemontPositionField,
    ReportCheckListFilter,
    ReportRemarkImportantCheckbox
  },
  mixins: [reportCheckListFilter],
  props: {
    report: {
      default: null,
      type: Object
    },
    reportRoles: {
      type: Object,
      default () {
        return {}
      }
    },
    request: {
      type: Object,
      default () {
        return {}
      }
    },
    serviceObject: {
      type: Object,
      default: null
    },
    insideReportRoads: {
      type: Boolean,
      default: false
    },
    isAudit: {
      type: Boolean,
      default: false
    },
    showExecutorCheckList: {
      type: Boolean,
      default: false
    },
    showMobileView: {
      type: Boolean,
      default: false
    },
    showExecutorsSections: {
      type: Boolean,
      default: false
    },
    applicantDescription: {
      type: String,
      default: null
    },
    docsHeaderFixed: {
      type: Boolean,
      default: true
    }
  },
  data: function () {
    return {
      defaultOpenCollapseMaterials: false,
      expansionPhotos: false,
      expansionDocs: false,
      commentTokenLoading: false,
      technologicalOperationsRemarks: [],
      imagesRemarks: [],
      remarksCount: 0,
      imgFilesNumber: 0,
      docFilesNumber: 0,
      collapsePanel: [],
      expansionItem: {
        executor: false,
        reinforcementExecutor: false,
        initiatorRequests: false,
        activeAndInitiatedRequests: false,
        auditRemarks: false,
        maintenanceNotes: false,
        cityMessengerBotSection: false,
        imgFiles: false,
        docFiles: false,
        yandexTasks: true,
        performedTasksCheckList: false,
        performedTasksCheckListContractor: false,
        history: false,
        revisionJournal: false,
        generalInfo: false,
        materials: false,
        revisionJournalForReworks: false
      },
      maintenanceNotesLength: 0,
      hasNotFixedMaintenanceNotes: false,
      objectActiveRequests: []
    }
  },
  computed: {
    remarksSectionTitle: function () {
      return `ЗАМЕЧАНИЯ К ОТЧЕТУ (${this.remarksCount})`
    },
    serviceObjectMaintenanceNotesTableSourceProps: function () {
      return { recordSource: 'requestReport', serviceObjectId: this.serviceObject.id, serviceObjectName: this.serviceObject.name, serviceObjectType: this.serviceObject.type.key, requestReportId: this.report.id, id: this.report.id }
    },
    activeAndInitiatedRequests: function () {
      let result = []
      if (this.report.initiatedRequests && this.report.initiatedRequests.length) {
        result = result.concat(this.report.initiatedRequests.map(request => {
          request.typeActiveInitiated = 'initiated'
          return request
        }))
      }
      if (this.objectActiveRequests.length) {
        result = result.concat(this.objectActiveRequests.map(request => {
          request.typeActiveInitiated = 'active'
          return request
        }))
      }
      return result
    }
  },
  watch: {
    showMobileView: {
      handler: function (value) {
        if (value) {
          this.collapsePanel = ['revisionJournalForReworks']
        }
      },
      immediate: true
    }
  },
  mounted: function () {
    if (this.$refs.maintenanceNotes) {
      this.$watch(
        () => this.$refs.maintenanceNotes.notes,
        (val) => {
          const notFixedNotes = val.filter(note => note.maintenanceNoteStatus.key === 'notFixed')
          this.maintenanceNotesLength = notFixedNotes.length || 0
          this.hasNotFixedMaintenanceNotes = val.some(note => note.maintenanceNoteStatus.key === 'notFixed')
        }
      )
    }
  },
  created: function () {
    EventBus.$on('show-reinforcements', this.onShowReinforcements)
    if (this.report != null) {
      this.$set(this.report, 'checking', true)
      this.updateCollapsePanel()
      this.prepareImages()
      this.onTechnologicalOperationsRemarkChanged()
      this.onImagesRemarkChanged()
      this.loadActiveRequests()
    }
    this.setCurrentDocumentValidationErrors(0)
  },
  beforeDestroy: function () {
    EventBus.$off('show-reinforcements', this.onShowReinforcements)
  },
  methods: {
    ...mapActions({
      setCurrentDocumentValidationErrors: 'setCurrentDocumentValidationErrors'
    }),
    showCheckListHelp: function () {
      this.$d.dialog(this).show({
        maximizedOnNarrow: true,
        contentComponent: ReportCheckListLegend,
        headerLabel: 'Справка по чек-листу',
        contentWidth: 1000,
        contentProps: {
          mobile: this.showMobileView
        }
      })
    },
    onCopyCommentToken: function () {
      this.commentTokenLoading = true
      axiosGet({
        url: '/service/delta/report/getCommentToken?reportId=' + this.report.id,
        onSuccess: (response) => {
          const result = response.data
          const token = result ? result.token : result
          if (!token) {
            this.$q.notify({
              type: 'negative',
              message: 'Не удалось получить токен для операции вставки текста в поле "Общий комментарий к работам"',
              progress: true,
              timeout: 3000
            })
            return
          }
          const reportNumber = this.report.name ? this.report.name.split('№')[1] : null
          const text = `reportNumber=${reportNumber}&token=${token}`
          const data = [new window.ClipboardItem({ 'text/plain': new Blob([text], { type: 'text/plain' }) })]
          return navigator.clipboard.write(data).then(() => {
            this.$q.notify({
              type: 'positive',
              message: 'Токен скопирован',
              progress: true,
              timeout: 3000
            })
          })
        },
        onFailure: 'Ошибка получения токена для операции вставки текста в поле "Общий комментарий к работам"',
        msgTarget: this
      }).finally(() => {
        this.commentTokenLoading = false
      })
    },
    onAddCommonCheckListRemark: function () {
      if (!this.report.commonRemark) {
        this.report.commonRemark = {
          active: true,
          code: 'commonRemark',
          comment: null,
          important: false,
          done: false
        }
      } else {
        this.report.commonRemark.active = true
      }
    },
    onDeleteCommonCheckListRemark: function () {
      if (this.report.commonRemark) {
        this.report.commonRemark.active = false
      }
    },
    onShowReinforcements: function () {
      this.$set(this.expansionItem, 'reinforcementExecutor', true)
      this.$refs.reinforcementExecutorSection.$el.scrollIntoView({ behavior: 'smooth' })
    },
    updateCollapsePanel: function () {
      if (this.showMobileView) {
        this.collapsePanel = ['revisionJournalForReworks']
      } else {
        this.collapsePanel = ['performedTasksCheckList', 'performedTasksCheckListContractor', 'cityMessengerBotSection']
        if (!this.insideReportRoads) {
          this.collapsePanel.push('imgFiles')
        }

        this.defaultOpenCollapseMaterials = true
        if (this.reportRoles.roleExecutor) {
          this.collapsePanel.push('materials')
          // this.defaultOpenCollapseMaterials = true
        } else {
          this.collapsePanel.push('executor')
        }
      }

      if (this.report.auditRemarks || (this.report.auditRemarksDocuments && this.report.auditRemarksDocuments.length > 0)) {
        this.collapsePanel.push('auditRemarks')
      }
      if (this.report.initiatorRequests && this.report.initiatorRequests.length !== 0) {
        this.collapsePanel.push('initiatorRequests')
      }
      if (this.report.initiatedRequests && this.report.initiatedRequests.length !== 0) {
        this.collapsePanel.push('initiatedRequests')
      }
      if (this.report.yandexTasks && this.report.yandexTasks.length) {
        this.collapsePanel.push('yandexTasks')
      }
      Object.entries(this.expansionItem).forEach(([key, item]) => {
        this.$set(this.expansionItem, key, this.collapsePanel.includes(key))
      })
    },
    validate: function (action) {
      let valid = true
      if (this.$refs.project) {
        valid &= this.$refs.project.validate(action)
      }
      if (this.$refs.executorSection) {
        valid &= this.$refs.executorSection.validate(action)
      }
      return valid
    },
    onWorkTypesChanged: function ({ workTypes, workTypesToRemove }) {
      this.report.workTypes = workTypes
      this.report.workTypesToRemove = workTypesToRemove
    },
    onContractorWorkTypesChanged: function ({ workTypes, workTypesToRemove }) {
      this.report.workTypesContractor = workTypes
      this.report.workTypesToRemoveContractor = workTypesToRemove
    },
    onUpdateFilesNumber: function (filesNumber, type) {
      if (type == 'imgFiles' && filesNumber && !this.insideReportRoads) {
        this.expansionPhotos = true
      } else if (type == 'docFiles' && filesNumber) {
        this.expansionDocs = true
      }
      this.$nextTick(() => {
        this[type + 'Number'] = filesNumber // imgFilesNumber, docFilesNumber
      })
    },
    onDefaultRemark: function (remark) {
      this.$emit('default-remark', remark)
    },
    onRemarksCount: function (count) {
      this.remarksCount = count || 0
    },
    onReportUpdated: function () {
      this.$emit('report-updated')
    },
    onTechnologicalOperationsRemarkChanged: function () {
      const allWorkTypes = []
      for (let i = 0; i < this.report.workPackages.length; i++) {
        const workPackageWorkTypes = this.report.workPackages[i].workTypes
        allWorkTypes.push(...workPackageWorkTypes)
      }
      allWorkTypes.push(...this.report.workTypes)

      const technologicalOperationsRemarks = []
      for (const workType of allWorkTypes.filter(workType => workType.includedInCurrentReport)) {
        for (const technologicalOperation of workType.technologicalOperations) {
          if (technologicalOperation.remark) {
            const remark = {
              name: technologicalOperation.name,
              get comment () {
                return technologicalOperation.remarkComment
              },
              set comment (value) {
                technologicalOperation.remarkComment = value
              },
              get done () {
                return technologicalOperation.remarkDone
              },
              set done (value) {
                technologicalOperation.remarkDone = value
              },
              get important () {
                return technologicalOperation.remarkImportant
              },
              set important (value) {
                technologicalOperation.remarkImportant = value
              }
            }

            technologicalOperationsRemarks.push(remark)
          }
        }
      }
      this.technologicalOperationsRemarks = technologicalOperationsRemarks
    },
    onImagesRemarkChanged: function () {
      const imagesRemarks = []
      this.addImagesRemarks(imagesRemarks, this.report.remarks)
      this.addImagesRemarks(imagesRemarks, this.report.imagesRemarks)
      this.imagesRemarks = imagesRemarks
    },
    addImagesRemarks: function (resultRemarks, sourceRemarks) {
      for (const imagesRemark of sourceRemarks) {
        if (imagesRemark.active) {
          const categoryObject = DEFAULT_REPORT_IMAGES_CATEGORIES_MAP[imagesRemark.code]
          if (categoryObject) {
            const files = []
            let filesText
            if (imagesRemark.documentsIds && imagesRemark.documentsIds.length) {
              const filesGroup = this.report.filesGroupsContainers.guiImgFiles.getFilesGroup(imagesRemark.code)
              if (filesGroup) {
                for (const id of imagesRemark.documentsIds) {
                  const remarkFileIndex = filesGroup.files.findIndex(fileWrapper => fileWrapper.document.id === id)
                  if (remarkFileIndex != -1) {
                    const remarkFile = filesGroup.files[remarkFileIndex]

                    // Поля файла в соответсвии с его замечаниями
                    if (!remarkFile.remarks) {
                      this.$set(remarkFile, 'remarks', [])
                    }
                    if (remarkFile.remarks && !remarkFile.remarks.includes(imagesRemark)) {
                      remarkFile.remarks.push(imagesRemark)
                    }

                    const hasActiveRemark = !!remarkFile.remarks.filter(r => r.active).length
                    remarkFile.props.readonly = !this.report.actionsAccess.editRemarks && hasActiveRemark
                    //

                    files.push(remarkFile)
                  } else {
                    filesText += (remarkFileIndex + 1)
                  }
                }
              }

              if (imagesRemark.fileIndex && imagesRemark.fileIndex.length) {
                filesText = '№: ' + imagesRemark.fileIndex.join(', ')
              } else {
                filesText = 'Файлы не определены'
              }
            } else {
              filesText = 'Вся секция'
            }

            const resultRemark = Object.assign({
              name: categoryObject.name,
              files,
              filesText
            }, imagesRemark)
            Object.defineProperty(resultRemark, 'comment', {
              get: function () {
                return imagesRemark.comment
              },
              set: function (value) {
                imagesRemark.comment = value
              }
            })
            Object.defineProperty(resultRemark, 'done', {
              get: function () {
                return imagesRemark.done
              },
              set: function (value) {
                imagesRemark.done = value
              }
            })
            Object.defineProperty(resultRemark, 'important', {
              get: function () {
                return imagesRemark.important
              },
              set: function (value) {
                imagesRemark.important = value
              }
            })

            resultRemarks.push(resultRemark)
          }
        }
      }
    },
    loadActiveRequests: function () {
      if (this.serviceObject) {
        loadObjectActiveRequests(this.serviceObject.id, this)
          .then(requests => {
            requests.forEach(request => {
              request.objectType = this.serviceObject.type && this.serviceObject.type.name
              request.objectNumber = this.serviceObject.number
            })
            this.objectActiveRequests = requests
          })
      }
    },
    onModalActualityOpened: function () {
      this.$emit('modal-actuality-opened')
    },
    onModalActualityСontractorOpened: function () {
      this.$emit('modal-actuality-contractor-opened')
    },
    prepareImages: function () {
      // if (this.report.documents.length > 0 || this.report.remarks[1].active || this.report.remarks[2].active ||
      //     this.report.remarks[3].active || this.report.remarks[4].active || this.report.remarks[5].active) {
      //   if (this.report.riBrigades && this.report.riBrigades.length != 0) {
      //     this.collapsePanel.push(2)
      //   } else {
      //     this.collapsePanel.push(1)
      //   }
      // }
    }
  }
}

